import { UrlService } from '@omnia/ui/src/lib'
import type { Showtime } from '@vista-digital/ocapi-types/v1'
import type { AccountSubPages, PagesEnum, TicketingSubPages } from './models/pages'
import { navigationService } from './navigation.service'

export class CurzonUrlService extends UrlService<PagesEnum, TicketingSubPages & AccountSubPages> {
    protected filmDetailsPage: keyof PagesEnum = 'FilmDetails'
    protected cinemaPage: keyof PagesEnum
    protected navigationService = navigationService

    // Add custom methods here
    public getShowtimeUrl(showtime: Showtime, keepParams = false, extraParams = {}) {
        return this.navigationService.getPageUrl(
            'Ticketing',
            { showtimeId: showtime.id, ...extraParams },
            keepParams,
             
            showtime.isAllocatedSeating ? 'SeatPicker' : 'TicketingLogin'
        )
    }
}

export const urlService = new CurzonUrlService()
